import jot from '../lib/jot'

export default jot
